export enum TicketSortType {
  Id,
  CreationDateTime,
  CustomerName,
  ProjectName,
  TicketTypeName,
  Title,
  Priority,
  TicketStatus,
  CreatorUserFullName,
  AssignedEmployeeFullName,
  IsDeleted,
  EditDateTime
}
